import { render, staticRenderFns } from "./refundOrderDetail.vue?vue&type=template&id=0b2590ec&scoped=true&"
import script from "./refundOrderDetail.vue?vue&type=script&lang=js&"
export * from "./refundOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2590ec",
  null
  
)

export default component.exports